import {
  SalaryCardActions,
  SalaryCardState,
  SalaryCardActionTypes,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  salaryCardList: [],
  salaryStatus: 'idle',
  salaryError: null,

  xrf: '',

  orderStatusList: [],
  orderStatusListStatus: 'idle',
  orderStatusListError: null,

  deletedOrder: [],
  deletedOrderStatus: 'idle',
  deletedOrderError: null,
  salaryCardListExcelStatus: 'failed',
  salaryCardListExcelError: undefined,
  trustedPersonList: [],
  trustedStatus: 'failed',
}

export const salaryCardReducer = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_SALARY_CARD_REQUEST:
      return {
        ...state,
        salaryStatus: 'loading',
        salaryError: null,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_SUCCESS:
      return {
        ...state,
        salaryStatus: 'success',
        salaryCardList: action.payload,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_FAILURE:
      return {
        ...state,
        salaryStatus: 'failed',
        salaryError: action.payload,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_REQUEST:
      return {
        ...state,
        detailInfoStatus: 'loading',
        detailInfoError: null,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_SUCCESS:
      return {
        ...state,
        detailInfoStatus: 'success',
        detailInformationList: action.payload,
      }
    case SalaryCardActionTypes.FETCH_SALARY_CARD_DETAIL_INFO_FAILURE:
      return {
        ...state,
        detailInfoStatus: 'failed',
        detailInfoError: action.payload,
      }
    case SalaryCardActionTypes.SET_XRF_VALUE:
      return {
        ...state,
        xrf: action.payload,
      }
    case SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_REQUEST:
      return {
        ...state,
        orderStatusListStatus: 'loading',
        orderStatusListError: null,
      }
    case SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_SUCCESS:
      return {
        ...state,
        orderStatusListStatus: 'success',
        orderStatusList: action.payload,
      }
    case SalaryCardActionTypes.FETCH_ORDERS_STATUS_LIST_FAILURE:
      return {
        ...state,
        orderStatusListStatus: 'failed',
        orderStatusListError: action.payload,
      }

    case SalaryCardActionTypes.FETCH_DELETED_ORDER_REQUEST:
      return {
        ...state,
        deletedOrderStatus: 'loading',
        deletedOrderError: null,
      }
    case SalaryCardActionTypes.FETCH_DELETED_ORDER_SUCCESS:
      return {
        ...state,
        salaryCardList: [
          ...state.salaryCardList?.filter(
            (value) => value.orderNo !== action.payload.id
          ),
        ],
        deletedOrderStatus: 'success',
      }
    case SalaryCardActionTypes.FETCH_DELETED_ORDER_FAILURE:
      return {
        ...state,
        deletedOrderStatus: 'failed',
        deletedOrderError: action.payload,
      }
      case SalaryCardActionTypes.RESET_DELETED_ORDER_STATUS:
        return {
          ...state,
          deletedOrderStatus: "idle",
        };
    default:
      return state
  }
}
